import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_RED } from "../../../config/constants";

const Track15DRed = ({ state, workState, onLabelClick }) => (
	<g id="Track15DRed" transform="translate(2165.000000, 1067.000000)" className="track">
		<line x1="68.5367195" y1="81" x2="-9.9475983e-14" y2="0.5" id="line"
					stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
					strokeWidth={tracksWidth}
					strokeLinecap="round"/>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track15DRed')}
			coords="2.976539, 6.023281"
			text="15D"
			textCoordsX="6.91308594"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
		/>
	</g>

);

Track15DRed.propTypes = trackPropTypes;

export default Track15DRed;
